import type { ComponentProps } from "react";
import { cn } from "../lib/cn";

export function Input({ className, type, inputMode, ...props }: ComponentProps<"input">) {
  return (
    <input
      type={type}
      // A roaster fills these in on a tablet with one hand (US-04.7). A numeric field asks for the
      // decimal pad rather than the full keyboard unless the caller wants something else; whole-number
      // fields pass inputMode="numeric" themselves.
      inputMode={inputMode ?? (type === "number" ? "decimal" : undefined)}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-card px-3 py-1 text-sm shadow-xs transition-colors",
        "placeholder:text-muted-foreground transition-shadow focus-visible:border-ring focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/20 disabled:cursor-not-allowed disabled:opacity-50",
        "aria-invalid:border-destructive",
        className,
      )}
      {...props}
    />
  );
}
